import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetPricedArticleResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object:
                    {
                        'article': {
                            'code': '4233',
                            'name': 'Baguette',
                            'fantasy_name': 'Baguette',
                            'items_amount': 20,
                            'category': 'Panadería Francesa',
                            'description': 'Descripción',
                            'weight': '20kg',
                            'measures': '20cm',
                            'cooking_time': '45 minutos',
                            'cooking_temperature': '200',
                            'ingredients': 'Harina',
                            'file': 'url/img.jpg',
                            'specification_sheet': 'url/specification_sheet.pdf'
                        },
                        'price': {
                            'amount': 5,
                            'currency': 'ARS'
                        }
            },
            errors: []
        }
    }

    articleInformation() {
        return {
            article: this._adaptArticle(this.content().article),
            price: this._adaptPrice(this.content().price),
            unitPrice: this._adaptPrice(this.content().unit_price),
        }
    }

    _adaptArticle(article) {
        return {
            'code': article.code,
            'name': article.name,
            'fantasyName': article.fantasy_name,
            'itemsAmount': article.items_amount,
            'itemsUnit': article.items_unit,
            'category': article.category.name,
            'categoryImage': article.category.black_logo_image,
            'description': article.description,
            'weight': article.weight,
            'measures': article.measures,
            'cookingTime': article.cooking_time,
            'cookingTemperature': article.cooking_temperature,
            'ingredients': article.ingredients,
            'file': article.file,
            'specificationSheet': article.specification_sheet
        }
    }

    _adaptPrice(price) {
        return {
            'amount': parseFloat(price.amount),
            'currency': price.currency,
        }
    }
}